export const StyleConstants = {
    mainBgColor: '#002060',
    componentBgColor: '#173263',
    highlightBgColor: '#5F85C6',
    tableCellBgColor: '#D9D9D9',
    reportTitleBgColor: '#003DAD',
    reportBoxBgColor: '#042778',
    borderColor: '#FFFFFF',
    fontColor: '#FFFFFF',
    normalColor: '#03FF09',
    faultLevelOne: '#FF0000',
    faultLevelTwo: '#FFC000',
    offLightColor: '#A6A6A6',
    highlightTabColor: '#2F5597',
    routeUpColor: '#00F3FF',
    routeDownColor: '#1FADFF',
};

export const Styles = {
    contentFont1: {
        color: StyleConstants.fontColor,
        fontSize: '16px',
        fontWeight: 900
    },
    contentFont2: {
        color: StyleConstants.fontColor,
        fontSize: '22px',
        fontWeight: 900
    },
    contentFont3: {
        color: StyleConstants.fontColor,
        fontSize: '26px',
        fontWeight: 900
    },
    contentFont4: {
        color: StyleConstants.fontColor,
        fontSize: '36px',
        fontWeight: 900
    },
    menuItem: {
        width: '54px',
        height: '54px',
        margin: '3px',
        cursor: 'pointer',
    },
    tableHeader: {
        color: StyleConstants.fontColor,
        lineHeight: '1',
        fontSize: '16px',
        fontWeight: 900,
        padding: '8px',
    },
    tableCell: {
        backgroundColor: StyleConstants.tableCellBgColor,
        color: '#000000',
        lineHeight: '1',
        fontSize: '16px',
        fontWeight: 900,
        padding: '0px 8px',
    },
    routeSelect: {
        width: '600px',
        height: '60px',
        color: StyleConstants.fontColor,
        backgroundColor: StyleConstants.mainBgColor,
        fieldset: {
            borderColor: StyleConstants.borderColor,
        },
        "& .MuiSelect-icon": {
            fill: StyleConstants.fontColor,
        },
    },
    carSelect: {
        width: '150px',
        height: '50px',
        fontSize: '36px',
        color: StyleConstants.fontColor,
        backgroundColor: StyleConstants.mainBgColor,
        fieldset: {
            borderColor: StyleConstants.borderColor,
        },
        "& .MuiSelect-icon": {
            fill: StyleConstants.fontColor,
            color: StyleConstants.fontColor,
        },
    },
    deviceSelect: {
        width: '400px',
        height: '50px',
        fontSize: '36px',
        color: StyleConstants.fontColor,
        backgroundColor: StyleConstants.mainBgColor,
        fieldset: {
            borderColor: StyleConstants.borderColor,
        },
        "& .MuiSelect-icon": {
            fill: StyleConstants.fontColor,
            color: StyleConstants.fontColor,
        },
    },
    carSystemStatusSelect: {
        width: '450px',
        height: '50px',
        color: StyleConstants.fontColor,
        backgroundColor: StyleConstants.mainBgColor,
        fieldset: {
            borderColor: StyleConstants.borderColor,
        },
        "& .MuiSelect-icon": {
            fill: StyleConstants.fontColor,
        },
    },
    carCell: {
        padding: '0px 8px',
        height: '25px',
    },
    carBorderCell: {
        borderLeft: '2px solid ' + StyleConstants.borderColor,
        height: '25px',
        padding: '0px 8px',
    },
    carBorderCellRight: {
        borderLeft: '2px solid ' + StyleConstants.borderColor,
        height: '25px',
        textAlign: 'right',
        padding: '0px 8px',
    },
    paginationText: {
        color: StyleConstants.fontColor,
        fontSize: '18px',
        fontWeight: 700,
        backgroundColor: 'transparent',
        border: 'none',
        cursor: 'pointer',
    },
    light: {
        fontSize: '24px',
    },
    lightDisplay: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
    },
    bigIcon: {
        width: '256px',
        height: '256px',
        color: StyleConstants.fontColor,
    },
};